export default "__VITE_ASSET__DG0d5Mot__"